import { createSlice } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { getCustomerWithInsurance, updateCustomer } from '../../../api/customerAPI';
import { InsuranceStatus } from '../../../app/constants';

export const insuranceSlice = createSlice({
  name: 'insurance',
  initialState: {
    customers: [],
    pagination: {},
    searchValue: '',
    page: 0,
    rowsPerPage: 100,
    sort: 'desc',
    sortBy: 'insurance.startDate',
    selectedId: null,
    selectedCustomer: null,
    editModalOpen: false,
    successMessage: "",
    errorMessage: ""
  },
  reducers: {
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    showEditModal: (state, action) => {
      state.editModalOpen = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    }
  }
});

export const { setSearchValue, setSelectedId, setSelectedCustomer, setPage, setRowsPerPage, setPagination, setSort, setSortBy, setCustomers, showEditModal, setSuccessMessage, setErrorMessage } = insuranceSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.vendor.value)`
export const selectState = state => state.insurance;

export const handleGetCustomers = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const response = await getCustomerWithInsurance(state.insurance.page, state.insurance.rowsPerPage, state.insurance.sort, state.insurance.sortBy,  [InsuranceStatus.SUBSCRIBED, InsuranceStatus.UNSUBSCRIBED, InsuranceStatus.TERMINATING], state.insurance.searchValue);
    const { content, ...pagination } = response.data;

    dispatch(setPagination(pagination));
    dispatch(setCustomers(content));
    dispatch(setSelectedId(null));
  } catch (error) {
    dispatch(setErrorMessage(error.message));
  } finally {
    dispatch(hideLoading());
  }
};

export const handleUpdateInsurance = (data) => async (dispatch, getState) => {
  dispatch(showLoading());

  try {
    await updateCustomer(data);
    dispatch(showEditModal(false));
    dispatch(setSuccessMessage("Successfully updated insurance details!"));
    dispatch(handleGetCustomers());
    dispatch(setSelectedId(null));
  } catch (error) {
    dispatch(setErrorMessage(error.message));
  } finally {
    dispatch(hideLoading());
  }
};

export default insuranceSlice.reducer;